export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt-BR": {
        "secureEnvironment": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ambiente Seguro"])};fn.source="Ambiente Seguro";return fn;})()
      },
      "en-US": {
        "secureEnvironment": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Secure Environment"])};fn.source="Secure Environment";return fn;})()
      }
    }
  })
}
